import React from "react";
import "@/App.css";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Invitation from "./components/Invitation";
import Timeline from "./components/Timeline";
import EventSection from "./components/EventSection";
import Footer from "./components/Footer";
import AutoScroll from "./components/AutoScroll";
import { EVENTS } from "./lib/invitationData";

function App() {
    const byId = Object.fromEntries(EVENTS.map((e) => [e.id, e]));
    return (
        <div className="App" data-testid="app-root">
            <Navigation />
            <main>
                <Hero />
                <Invitation />
                <Timeline />
                <EventSection event={byId.shukrana} variant="shukrana" />
                <EventSection event={byId.nikah} variant="nikah" />
                <EventSection event={byId.valima} variant="valima" />
            </main>
            <Footer />
            <AutoScroll />
        </div>
    );
}

export default App;
